import { apiClient } from "@/lib/apiClient";
import type { SpaceSummary } from "@mind-sands/shared";

/** Landing page API — space listing for emotion-first entry */
export const landingApi = {
  async listSpaces(): Promise<SpaceSummary[]> {
    return apiClient.get("/api/spaces");
  },
};
